import React from 'react';
import AppLayout from './containers/AppLayout';

const App = () => {
    return <AppLayout />;
};

export default App;
